module.exports = __webpack_public_path__ + "img/star_3.015f7ce4.jpg";